import * as React from 'react';
import {setScreen,saveGloop,deactivate} from "../../actions/activation";
import {Share, updateGloop} from "../../actions/update";
import {userCanShare} from "../../functions";

export default class TopBar extends React.Component {
	state = {};

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className={'gloop-top-bar'}>
				<a
					href={'#'}
					className={'gloop-save-draft'}
					onClick={deactivate}
				>Draft saved</a>
				<a
					href={'#'}
					className={'gloop-share btt'}
					onClick={()=>{
						updateGloop({},true);
						setScreen('share');
					}}
				>SEND</a>
			</div>
		)
	}
}